export const MAX_STUDENTS_GROUP_TEACHER = 10;
